var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Header',[_c('UiTabs',[_c('UiTab',{attrs:{"to":"/shop"}},[_vm._v("Shop")]),_c('UiTab',{attrs:{"to":"/shop/tokens"}},[_vm._v("Tokens")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }